// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Domain: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 38" enableBackground="new 0 0 42 38" xmlSpace="preserve">
<g>
	<rect x="29.33" y="25.25" width="4.17" height="4.17"/>
	<rect x="29.33" y="16.92" width="4.17" height="4.17"/>
	<path d="M21,8.58V0.25H0.17v37.5h41.67V8.58H21z M8.5,33.58H4.33v-4.17H8.5V33.58z M8.5,25.25H4.33v-4.17H8.5V25.25z M8.5,16.92
		H4.33v-4.17H8.5V16.92z M8.5,8.58H4.33V4.42H8.5V8.58z M16.83,33.58h-4.17v-4.17h4.17V33.58z M16.83,25.25h-4.17v-4.17h4.17V25.25z
		 M16.83,16.92h-4.17v-4.17h4.17V16.92z M16.83,8.58h-4.17V4.42h4.17V8.58z M37.67,33.58H21v-4.17h4.17v-4.17H21v-4.17h4.17v-4.17
		H21v-4.17h16.67V33.58z"/>
</g>
</svg>;
};

export default React.memo(Domain);
